<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">
                {{ 'Details'|translate }}
            </span>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        <span *ngIf="loading">{{'Loading details...'|translate}}</span>
        <table class="table" *ngIf="!loading" style="border-collapse: collapse;">
            <thead>
            <tr>
                <th>{{'From'|translate}}</th>
                <th>{{'To'|translate}}</th>
                <th>{{'Time'|translate}}</th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let item of workTimeSummaryList.items">
                <td>{{item.startWork|date: 'dd.MM.y HH:mm:ss':'UTC+2': locale}}</td>
                <td>{{item.endWork|date: 'dd.MM.y HH:mm:ss':'UTC+2': locale}}</td>
                <td>{{item.timeString}}</td>
            </tr>
            </tbody>
        </table>
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close()"
                aria-label="Close">
            {{'Close'|translate}}
        </button>

    </div>
</div>
